import { useRef } from "react";

//Why did we decide to use refs? Too long to explain: https://css-tricks.com/dealing-with-stale-props-and-states-in-reacts-functional-components/

export default function useNoRenderRef<T>(currentValue: T) {
  const ref = useRef(currentValue);
  ref.current = currentValue;
  return ref;
}
